import React, { useEffect, useState } from "react";
import { SeedType, delete_user_data_from_client_side, errorToast, get_user_data } from "../../utils/common";
import MultipleLoadingScreen from "../../design-system/MultipleLoadingScreen";
import { useLocation, useNavigate } from "react-router-dom";
import DraftItem from "./DraftItem";
import { deletePrivateContent, getDraftPublishContentList, getPrivateContentFileNames } from "../../api/axiosApi";
import { ToastContainer } from "react-toastify";
import { Button, Dialog, DialogBody, DialogFooter, DialogHeader } from "@material-tailwind/react";

function MyExclusiveContentList() {
    const [draftContent, setDraftContent] = useState<SeedType[]>([]);
    const [error, setError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const location = useLocation();
    const navigate = useNavigate();
    const [userExclusiveDataAvailable, setUserExclusiveDataAvailable] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [selectedFileToDelete, setSelectedFileToDelete] = useState<string | null>(null);

    const handleOpen = () => setOpen(!open);
    const confirmDelete = (fileName?: string) => {
        if (fileName){
            setSelectedFileToDelete(fileName);
            setOpen(true);
        }
    };
    const fetchAndSetDraft = async () => {
        try {
            if (get_user_data() !== null && get_user_data() !== undefined) {
                // const exclusiveFilesResponse = await getPrivateContentFileNames();
                const draftOrPublishedFilesResponse = await  getDraftPublishContentList()
                const exclusiveFiles = await draftOrPublishedFilesResponse.data;

                const fetchedDraft: SeedType[] = [];
                for (const element of exclusiveFiles) {
                    try {
                        fetchedDraft.push(element);
                    } catch (error) {
                        console.error(`Failed to fetch data `, error);
                    }
                }

                setDraftContent(fetchedDraft);
                setIsLoading(false);
            } else {
                delete_user_data_from_client_side();
                navigate("/user_login");
            }
        } catch (error) {
            setError(true);
            console.error(`Failed to fetch caselet files `, error);
        }
    };

    useEffect(() => {
        fetchAndSetDraft();
    }, [location]);
    if (userExclusiveDataAvailable) {
        return (
            <div className=" flex justify-center items-center pb-4 w-full h-full ">
                <p className="p-2 flex  justify-center text-slate-500 font-bold">There is nothing to show here.</p>
            </div>
        );
    }
    // const handleDeleteDraft = async (fileName: string) => {
    //     const draftToDelete = draftContent.find(draft => draft.file_name === fileName);
    //     if (!draftToDelete) {
    //         console.error(`Draft with fileName ${fileName} not found`);
    //         return;
    //     }

    //     const userId = draftToDelete.user_id; // Extract userId from the found object
    //     if (userId) {
    //         try {
    //             const deletePrivateContentRes = await deletePrivateContent(fileName, userId);
    //             const deletePrivateContentJson = deletePrivateContentRes.data;
    //             if (deletePrivateContentJson.status === "success") {
    //                 setDraftContent(prevDrafts => prevDrafts.filter(draft => draft.file_name !== fileName));
    //             } else {
    //                 errorToast("Unable to delete");
    //             }
    //         } catch (error) {
    //             errorToast("Unable to delete");
    //         }
    //     }
    // };
    const handleDeleteConfirm = async () => {
        if (!selectedFileToDelete) return;

        const draftToDelete = draftContent.find(draft => draft.file_name === selectedFileToDelete);
        if (!draftToDelete) {
            console.error(`Draft with fileName ${selectedFileToDelete} not found`);
            setOpen(false);
            return;
        }

        const userId = draftToDelete.user_id;
        if (userId) {
            try {
                const res = await deletePrivateContent(selectedFileToDelete, userId);
                const json = res.data;
                if (json.status === "success") {
                    setDraftContent(prev => prev.filter(d => d.file_name !== selectedFileToDelete));
                } else {
                    errorToast("Unable to delete");
                }
            } catch (err) {
                errorToast("Unable to delete");
            }
        }

        setOpen(false);
        setSelectedFileToDelete(null);
    };
    if (isLoading && error === false) {
        return (
            <div className="p-4">
                <MultipleLoadingScreen count={3} />
            </div>
        );
    }

    if (error) {
        errorToast("Unable to load exclusive content.");
    }

    return (
        <div className=" ">
            <div className="flex-grow pb-8 ">
                {draftContent.map(draftObject => (
                    draftObject &&
                    <DraftItem key={draftObject.file_name} draft={draftObject} onDelete={() => confirmDelete(draftObject.file_name)}></DraftItem>
                ))}
            </div>
            <ToastContainer toastStyle={{ marginTop: "8vh" }} />
            <div>
                <Dialog open={open} handler={handleOpen} className="w-5/12 shadow-lg z-50 p-3 border rounded-xl bg-white">
                    <DialogHeader className="text-red-500">Confirm Deletion</DialogHeader>
                    <DialogBody>Are you sure you want to delete this draft?</DialogBody>
                    <DialogFooter>
                        <Button variant="text" color="red" onClick={handleOpen} className="mr-1">
                            Cancel
                        </Button>
                        <Button variant="gradient" color="green" onClick={handleDeleteConfirm} className="bg-green-600 shadow-sm">
                            Confirm
                        </Button>
                    </DialogFooter>
                </Dialog>
            </div>
        </div>
    );
}

export default MyExclusiveContentList;
